import { render, staticRenderFns } from "./StreakCard.vue?vue&type=template&id=c8b06af4&scoped=true&"
import script from "./StreakCard.vue?vue&type=script&lang=js&"
export * from "./StreakCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b06af4",
  null
  
)

export default component.exports